export default "__VITE_ASSET__BaQI1g65__"